import { Card } from "@/components/ui/card";
import { Skeleton } from "@/components/ui/skeleton";

const AssignPropertiesModalSkeleton = () => (
  <div className="space-y-4">
    <Skeleton className="h-6 w-3/4" />

    <div className="flex flex-col space-y-3">
      {[...Array(4)].map((_, i) => (
        <Card key={`property-${i}`} className="p-3 space-y-2">
          <div className="flex items-center space-x-3">
            <Skeleton className="h-5 w-5 rounded" />

            <div className="flex-1 space-y-1">
              <Skeleton className="h-5 w-2/3" />
              <Skeleton className="h-4 w-1/2" />
              <Skeleton className="h-4 w-1/3" />
            </div>
          </div>
        </Card>
      ))}
    </div>

    <div className="flex justify-between gap-2">
      <Skeleton className="h-10 w-[120px]" />

      <div className="flex gap-2">
        <Skeleton className="h-10 w-[90px]" />

        <Skeleton className="h-10 w-[170px]" />
      </div>
    </div>
  </div>
);

export default AssignPropertiesModalSkeleton;
